/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import geoLocationTemplate from './geo-location.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GeoLocationRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.geoLocation', {
            url: '/geoLocation',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value,
                types.authority.SUB_CUSTOMER_ADMIN.value, types.authority.SUB_CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: geoLocationTemplate,
                    controllerAs: 'vm',
                    controller: 'GeoLocationController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'geo-location.geo-locations'
            },
            ncyBreadcrumb: {
                label: '{"icon": "router", "label": "geo-location.geo-locations"}'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/geo-location/geo-location.routes.js